module.exports = __webpack_public_path__ + "static/media/中華R軟體學會.92b44260.jpg";